import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import lodash from "lodash"
import Select from 'react-select'
import { GpParam } from "../../types/GpParam"

export interface SelectOption
{
    label: string
    value: string
}

interface RenaultCategory
{
    code: string
    group: string
    label: string
}

interface RenaultApi
{
    data: RenaultCategory[]
    links: any[],
    meta: any
}

interface CategorieClient
{
    IDCatClient: number
    Descr: string
    TFicheCli: string
    EstActif: boolean
    CodeRenault: string | null
}

export default function List() {
    const [ values, setValues ] = useState<CategorieClient[]>([])
    const [ gpParams, setGpParams ] = useState<GpParam | null>(null)
    const [ codeRenaultOptions, setCodeRenaultOptions ] = useState<SelectOption[]>([])
    const [ showSaveCodeRenaultButton, setShowSaveCodeRenaultButton ] = useState<boolean>(false)

    const hydrateCatClientRen = (data: RenaultCategory[]) => {
        const selectOption = data.map((category) => {
            return {
                label: `${category.code} / ${category.label}`,
                value: category.code,
            } as SelectOption
        })

        setCodeRenaultOptions(selectOption)
    }

    const saveCodesRenault = () => {
        setShowSaveCodeRenaultButton(false)

        fetch(localStorage.backoffice_api + '/api/table/CategorieClient/renaultCode', {
            method: 'PATCH',
            headers: {
                "Content-Type": "application/json",
                authorization: localStorage.JWT,
            },
            body: JSON.stringify({ ...values }),
        }).catch((e) => {
            console.log("Error on update Renault Codes", e)
        })
    }

    const updateValues = (value: string, id: number) => {
        setValues(prevState =>
            prevState.map(v =>
                v.IDCatClient === id ? { ...v, CodeRenault: value } : v,
            ),
        )
    }

    const fetchValues = () => {
        fetch(localStorage.backoffice_api + '/api/table/CategorieClient', {
            method: 'GET',
            headers: {
                authorization: localStorage.JWT,
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response.json()
            })
            .then((json: CategorieClient[]) => {
                const values = lodash.sortBy(json, (value) => {
                    return value.Descr
                })
                setValues(values)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const fetchGpParams = () => {
        fetch(localStorage.backoffice_api + '/api/gpParametres', {
            method: 'GET',
            headers: {
                authorization: localStorage.JWT,
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response.json()
            })
            .then((json) => {
                setGpParams(json)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const fetchCategorieClientRenault = () => {
        fetch(localStorage.backoffice_api + '/api/renGateway/categoriesClient', {
            method: 'GET',
            headers: {
                authorization: localStorage.JWT,
            },
        }).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText)
            }
            return response.json()
        })
          .then((json: RenaultApi) => {
              hydrateCatClientRen(json.data)
          })
          .catch((error) => {
              console.log(error)
          })
    }

    useEffect(() => {
        const fetchData = async () => {
            fetchValues()
            await fetchGpParams()
            fetchCategorieClientRenault()
        }

        fetchData()
    }, [])

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col">
                    <h2>Catégories client</h2>
                    <br/>
                    <div>
                        <Link to="/table/CategorieClient/create" className="btn btn-light">
                            <i className="fa fa-plus"></i> Ajouter
                        </Link>
                    </div>
                    <br/>
                    <table className="table table-striped table-hover table-sm">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Type fiche client</th>
                            <th>Libellé</th>
                            {gpParams?.GRP_ClientRenault &&
                                <th>
                                    <div className="d-flex flex-row align-items-center" style={{ gap: '10px' }}>
                                        <span>Code Renault</span>
                                        {!showSaveCodeRenaultButton ? <button
                                                type="button"
                                                className="btn btn-light btn-sm"
                                                onClick={() => setShowSaveCodeRenaultButton(true)}
                                            >
                                                <i className="fa-solid fa-pen"></i>
                                            </button>

                                            : <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => saveCodesRenault()}
                                            >
                                                <i className="fa-solid fa-floppy-disk"></i>
                                            </button>
                                        }
                                    </div>
                                </th>
                            }
                            <th>Est actif</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {values.map((r: CategorieClient) => {
                            return (<tr key={r.IDCatClient}>
                                <td>{r.IDCatClient}</td>
                                <td>{r.TFicheCli}</td>
                                <td>{r.Descr}</td>
                                {gpParams?.GRP_ClientRenault &&
                                    <td>
                                        {showSaveCodeRenaultButton ? <Select
                                                multi={false}
                                                name="RenaultCategories"
                                                options={codeRenaultOptions}
                                                value={r.CodeRenault}
                                                onChange={(option: SelectOption | null) => updateValues(option?.value ?? "", r.IDCatClient)}
                                            />
                                            :
                                            <span>{r.CodeRenault ?? ""}</span>
                                        }
                                    </td>
                                }
                                <td>
                                    {r.EstActif && <i className="fa fa-check"></i>}
                                </td>
                                <td>
                                    <Link to={'/table/CategorieClient/' + r.IDCatClient} className="btn btn-primary btn-sm">
                                        <i className="fa fa-pencil"></i>
                                    </Link>
                                </td>
                            </tr>)
                        })}
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    )
}
